/**
 * SortIcon Component
 * Double-chevron sort indicator in a circular background for table headers.
 * Uses square viewBox to avoid distortion.
 */

import React from "react";
import type { IconProps } from "./types";
import { colors } from "../colors";

interface SortIconProps extends IconProps {
  /** Background circle fill (default: background[700]) */
  circleColor?: string;
}

const defaultChevronColor = colors.text[700];
const defaultCircleColor = colors.background[700];

const SortIcon: React.FC<SortIconProps> = ({
  size = 16,
  color = defaultChevronColor,
  circleColor = defaultCircleColor,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={8} cy={8} r={8} fill={circleColor} />
    <path
      transform="translate(0 -1.333)"
      d="M4.635 8.123c.043.05.095.09.151.117a.412.412 0 00.357 0 .466.466 0 00.151-.117l2.126-2.45a.467.467 0 01.151-.117.412.412 0 01.358 0 .467.467 0 01.15.117l2.127 2.45c.043.05.094.09.15.117a.411.411 0 00.358 0 .467.467 0 00.151-.117.579.579 0 00.135-.377.579.579 0 00-.135-.377l-2.13-2.455c-.262-.3-.616-.47-.985-.47-.37 0-.723.17-.984.47L4.635 7.369a.579.579 0 00-.135.377c0 .141.049.277.135.377zM10.865 10.603a.465.465 0 00-.151-.117.41.41 0 00-.357 0 .465.465 0 00-.151.117l-2.126 2.45a.466.466 0 01-.151.116.411.411 0 01-.358 0 .466.466 0 01-.15-.117l-2.127-2.45a.465.465 0 00-.15-.117.411.411 0 00-.358 0 .465.465 0 00-.151.118.579.579 0 00-.135.377c0 .141.049.277.135.377l2.13 2.455c.262.3.616.47.985.47.37 0 .723-.17.984-.47l2.131-2.455A.579.579 0 0011 10.98a.579.579 0 00-.135-.377z"
      fill={color}
    />
  </svg>
);

export default SortIcon;
